import apiClient, { PaginatedResponse } from '@/ApiClient/ApiClient'
import { AxiosRequestConfig } from 'axios'

// Service utility to handle paginated and non-paginated responses
export const apiService = {
  async fetchPaginated<T>(url: string, config?: AxiosRequestConfig): Promise<PaginatedResponse<T>> {
    return await apiClient.get<PaginatedResponse<T>>(url, { ...config, paginated: true })
  },
  async fetchSimple<T>(url: string, config?: AxiosRequestConfig): Promise<T[]> {
    const response = await apiClient.get<PaginatedResponse<T>>(url, { ...config, paginated: false })
    return response?.data || response
  },
}
